import React, { useContext, createContext } from 'react';
import useAxios from 'axios-hooks';
import environment from 'environment';

import { AuthContext } from './AuthContext';

export const BoomiContext = createContext();

const BoomiContextProvider = ({ children }) => {
  const { jwtToken } = useContext(AuthContext);

  // Trigger Boomi
  const [{ data: boomiResponse, loading: boomiLoading, error: boomiError }, triggerBoomi] = useAxios(
    {
      method: 'GET',
      url: `${environment.apiEndpoint}/boomi`,
      headers: { Authorization: jwtToken },
    },
    { manual: true }
  );

  return <BoomiContext.Provider value={{ boomiResponse, boomiLoading, boomiError, triggerBoomi }}>{children}</BoomiContext.Provider>;
};

export default BoomiContextProvider;
